export default __webpack_public_path__ + "static/hetzner_community_3-1851b02cd106f844305bf058d2a58735.jpg";